import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle } from 'lucide-react';
import { productCategories } from '../utils/mockData';
import { trackCategoryView, trackButtonClick } from '../utils/analytics';

export const CategoryDetail = () => {
  const { categorySlug } = useParams();
  const category = productCategories.find(cat => cat.slug === categorySlug);

  // Scroll to top when component mounts or categorySlug changes
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Track category view in GA4
    if (category) {
      trackCategoryView(category.name);
    }
  }, [categorySlug, category]);

  const toyProducts = [
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/rqy5u7lp_a59e5143bd862eed78596d71aa6f3aae.webp',
      title: 'My Little Box of Emotions',
      description: 'Eğitici duygular kutusu - Çocukların duygularını tanımasına yardımcı olan renkli ve eğitici ambalaj tasarımı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/ba2qy2kl_10dd08d0a083264a7dc636b3182db34d.jpg',
      title: 'Learning Resources TotBot',
      description: 'Sayı öğrenme robotu - İnteraktif oyuncaklar için dayanıklı ve çekici kutu ambalajı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/g7lbrxqy_oyuncak3.webp',
      title: 'Smart Toys Müzikli Tırtıl',
      description: 'Gelişim oyuncağı - Müzikli oyuncaklar için şeffaf pencereli, güvenli ambalaj çözümü'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/khrrioax_08f10b8c9c003b447a2a5d39f316c5f1.webp',
      title: 'Trefl Baby İlk Puzzle',
      description: 'Bebek eğitim seti - Küçük yaş grupları için güvenli, renkli ve dayanıklı kutular'
    }
  ];

  const petFoodProducts = [
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/gu99zgt4_11.png',
      title: 'Royalist Lamb Sticks',
      description: 'Köpek maması - Kuzu etli çubuk mama ambalajı - 24 adet'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/pxvdru10_4.jpg',
      title: 'Royalist Chicken & Liver Sticks',
      description: 'Kedi maması - Tavuk ve ciğerli çubuk mama ambalajı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/96cik6wq_10.png',
      title: 'Wildes Land Probierbox',
      description: 'Organik kedi maması - Doğal içerikli deneme paketi'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/c6pgrd0x_Royalist%20Food%20Sticks%20Box%20kapali%20mavi.png',
      title: 'Royalist Tuna & Shrimp Sticks',
      description: 'Kedi maması - Ton balığı ve karides çubuk mama'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/ujvdb582_9.JPG',
      title: 'ProChoice Adult Cat',
      description: 'Premium yetişkin kedi maması - Tahılsız yaş mama'
    }
  ];

  const catLitterProducts = [
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/md4h9i2e_topcat%206lt%20mockup.png',
      title: 'TopCat Hygiene White',
      description: 'Ultra compact kedi kumu - 6 litre'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/37689yva_mock%20aloe%20vera%20mockup%201.png',
      title: 'Fresh Cat Aloe Vera',
      description: 'Ultra clumping kedi kumu - 6 litre'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/5xua7ns2_3.jpg',
      title: 'K-Classic Ultra-Klumpstreu XXL',
      description: 'Premium kedi kumu - 8 litre'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/haxvtiwr_a9f867e6-74b7-471b-a48b-fbfc28511999.JPG',
      title: 'K-Classic Ultra-Klumpstreu',
      description: 'Ultra clumping kedi kumu - 6 litre'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/1l6csb5a_image001.JPG',
      title: 'Sanicat & Lindocat Premium',
      description: 'Premium kedi kumu kutuları - Çoklu marka çözümleri'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/xzvrx95u_7.jpg',
      title: 'Signor Gatto Agglomerante',
      description: 'Premium kalite kedi kumu - 6 litre'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/p73ann1g_8.jpg',
      title: "Cat's Way Unscented",
      description: 'Grey bentonite kedi kumu - 10 kg'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/9noqi6lg_katalog-anasayfa.png',
      title: 'Discover Your Cat Litter Box',
      description: 'Kedi kumu kutuları - Çeşitli markalar için özel tasarım ambalajlar'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/jfjpg75t_katalog-kutular.png',
      title: 'Cat Litter Boxes Collection',
      description: 'Kedi kumu kutu koleksiyonu - Farklı boyut ve tasarımlar'
    }
  ];

  const electricalProducts = [
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/6om34i31_nespresso-2-sa%C4%9F.jpg',
      title: 'Nespresso Kahve Makinesi',
      description: 'Premium kahve makinesi ambalajı - Beyaz tasarım'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/p1r8p7e3_nespresso-siyah-sol.jpg',
      title: 'Nespresso Kahve Makinesi Premium',
      description: 'Lüks kahve makinesi kutusu - Siyah tasarım'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/b0j25kex_tefal%20sol.jpg',
      title: 'Tefal Tost Makinesi',
      description: 'Tefal marka tost makinesi ambalajı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/50qqa0y1_1.jpg',
      title: 'Arzum Tost Makinesi',
      description: 'Arzum marka tost makinesi kutusu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/dnffd3yb_2.jpg',
      title: 'Nespresso Taşıma Saplı',
      description: 'Taşıma saplı kahve makinesi kutusu'
    }
  ];

  if (!category) {
    return (
      <div className="min-h-screen pt-20 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Kategori Bulunamadı</h1>
          <Link to="/urunler" className="text-lime-600 hover:text-lime-700">
            Ürünlere Geri Dön
          </Link>
        </div>
      </div>
    );
  }

  const isToyCategory = categorySlug === 'oyuncak';
  const isPetFoodCategory = categorySlug === 'pet-food';
  const isCatLitterCategory = categorySlug === 'cat-litter';
  const isElectricalCategory = categorySlug === 'elektrikli-ev-aletleri';
  const isHomeTextilesCategory = categorySlug === 'ev-tekstil';
  const isDetergentCategory = categorySlug === 'deterjan-temizlik';
  const isPaperHandleCategory = categorySlug === 'kagit-sapli-kutular';
  const isAutomotiveCategory = categorySlug === 'otomotiv';
  const isFoodCategory = categorySlug === 'gida';

  const toyDescription = [
    "Interpack Ambalaj'ın oyuncak kutuları, peluş oyuncaklardan Lego tipi ürünlere, çeşitli oyuncaklara kadar geniş bir yelpazede üretilen renkli ve dikkat çekici ambalaj çözümleridir.",
    "Bu kutular, yüksek kaliteli ofset baskı teknolojisiyle üretilir. Rafta ürünün öne çıkmasını sağlar, satışları artırır ve oyuncağa önemli bir katma değer katar. Interpack Ambalaj, çevreye duyarlı üretim süreçleriyle sürdürülebilirliğe önem verirken, çocukların yaratıcılığını ve hayal gücünü destekleyen yenilikçi, eğlenceli tasarımlar sunar.",
    "Uzman kadrosu ve modern makine parkuru sayesinde her türlü özel tasarım oyuncak kutusunu farklı boyut, şekil ve yapı seçenekleriyle gerçekleştirebilir. Ortaya çıkan kutular, sadece çocuklar için değil, yetişkinlerin de ilgisini çeken görsel ve kaliteli ambalajlardır.",
    "Kısaca: Oyuncaklarınız için hem göze hitap eden, hem kaliteli hem de çevre dostu kutu arıyorsanız, Interpack Ambalaj'ın oyuncak kutuları en iyi seçeneklerden biridir."
  ];

  const petFoodDescription = [
    "İnterpack Ambalaj, evcil hayvan yiyecek kutuları üretiminde kaliteli ve fonksiyonel çözümler sunmaktadır. Özellikle kedi ve köpek maması gibi evcil hayvan yemleri için tasarlanan bu kutular, büyük boy ofset baskı teknolojisiyle üretilerek raflarda dikkat çekici ve profesyonel bir görünüm kazanır.",
    "Kutular, kağıt tutamaç (sap) özelliği sayesinde hem yüksek dayanıklılık sağlar hem de taşıma kolaylığı sunar. Bu sayede hem üreticiler hem de son kullanıcılar için pratik bir kullanım deneyimi yaratır. Interpack Ambalaj, çevreye duyarlı üretim prensibiyle hareket ederek hayvan dostlarımızın sağlığına özen gösterir ve kaliteli malzemelerle titiz bir üretim süreci uygular.",
    "Deneyimli kadrosu ve modern üretim altyapısıyla hem Türkiye içindeki hem de yurt dışındaki müşterilere özel tasarım evcil hayvan yiyecek kutuları sunmaktadır. Canlı renkleri, güçlü yapısı ve kullanıcı dostu tasarımıyla bu kutular, ürününüzün pazarda daha iyi görünmesini ve daha kolay taşınmasını sağlar.",
    "Kısaca: Evcil hayvan yiyecekleriniz için hem göze hitap eden, hem dayanıklı hem de taşıması kolay ambalaj arıyorsanız, Interpack Ambalaj'ın özel üretim evcil hayvan yiyecek kutuları en doğru tercihtir."
  ];

  const catLitterDescription = [
    "Interpack Ambalaj, kedi kumu kutularında pratiklik ile görselliği bir arada sunan özel ambalaj çözümleri üretmektedir.",
    "Bu kutular, yüksek mukavemetli karton yapısı ve büyük boy ofset baskı teknolojisiyle üretilir. Canlı ve dikkat çekici tasarımları sayesinde market raflarında ve pet shoplar da ürününüzün hemen göze çarpmasını sağlar. Özellikle kutu üzerindeki %100 kağıttan üretilmiş geri dönüştürülebilir kağıt sap özelliği sayesinde 15 kg kadar kolayca taşıyabilirsiniz.",
    "Sağlam kenar yapısı ve kaliteli malzeme sayesinde kutular deforme olmadan uzun süre dayanır, istifleme ve depolama sırasında da avantaj sağlar. Interpack Ambalaj, çevreye duyarlı üretim anlayışı ile hem evcil hayvan sahiplerine hem de üreticilere pratik, hijyenik ve şık bir ambalaj alternatifi sunar.",
    "Kısaca: Kedi kumu için hem çok dayanıklı, hem taşıması kolay hem de rafta fark yaratan kutular arıyorsanız, Interpack Ambalaj'ın kedi kumu kutuları tam size göre."
  ];

  const electricalDescription = [
    "Interpack Ambalaj, elektrikli ev aletleri için güçlü, şık ve profesyonel ambalaj çözümleri üretmektedir.",
    "Elektrik süpürgesi, mutfak robotu, blender, tost makinesi gibi küçük ve orta boy ev aletlerinden, daha büyük beyaz eşya grubu ürünlere kadar geniş bir yelpazede kutu tasarımı ve üretimi yapıyoruz. Yüksek teknolojili ofset baskı sistemimiz sayesinde kutular canlı renkleri, keskin detayları ve modern tasarımlarıyla raflarda hemen dikkat çeker.",
    "Kutularımız özel mukavemetli karton yapısıyla ürününüzü nakliye ve depolama sırasında en iyi şekilde korur. İsteğe göre eklenen taşıma sapları, açılır-kapanır kapaklar ve iç takviyeler ile hem kullanıcı dostu hem de lojistik açısından pratik hale getirilir. Interpack Ambalaj, çevreye duyarlı üretim anlayışı ile kaliteli malzemeler kullanarak hem markanıza değer katar hem de sürdürülebilir bir ambalaj alternatifi sunar.",
    "Kısaca: Elektrikli ev aletleriniz için hem dayanıklı koruma sağlayan, hem göze hitap eden hem de taşıması kolay kutular arıyorsanız, Interpack Ambalaj'ın özel üretim elektrikli ev aletleri kutuları tam ihtiyacınıza göre tasarlanmıştır."
  ];

  const homeTextilesProducts = [
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/ioebs9yj_d1.png',
      title: 'Ev Tekstili Ambalaj 1',
      description: 'Premium ev tekstili ürünleri ambalajı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/levcnxms_d2.png',
      title: 'Ev Tekstili Ambalaj 2',
      description: 'Şık ve fonksiyonel ev tekstili kutusu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/nyx3xnvh_d3.jfif',
      title: 'Ev Tekstili Ambalaj 3',
      description: 'Nevresim ve yatak takımları için kutu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/eu3odelm_d4.jfif',
      title: 'Ev Tekstili Ambalaj 4',
      description: 'Havlu ve bornoz setleri ambalajı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/maq9y561_d5.jfif',
      title: 'Ev Tekstili Ambalaj 5',
      description: 'Özel tasarım ev tekstili kutuları'
    }
  ];

  const homeTextilesDescription = [
    "Interpack Ambalaj, ev tekstili ürünleri için şık, dayanıklı ve fonksiyonel ambalaj çözümleri sunmaktadır.",
    "Nevresim takımları, havlu setleri, battaniye, yatak örtüleri ve perde gibi ev tekstili ürünleri için özel tasarlanmış kutularımız, yüksek kaliteli ofset baskı teknolojisiyle üretilir. Canlı renkler, net detaylar ve modern tasarımlarla ürünleriniz raflarda hemen dikkat çeker ve müşterilerinize premium bir deneyim sunar.",
    "Özel mukavemetli karton yapısı sayesinde kutularımız hem nakliye hem de depolama sırasında ürünlerinizi korur. İsteğe göre şeffaf pencere, özel sap tasarımları ve iç takviyeler ile hem görsel hem de işlevsel avantajlar sağlar. Interpack Ambalaj, çevreye duyarlı üretim anlayışıyla kaliteli ve sürdürülebilir malzemeler kullanarak markanıza değer katar.",
    "Kısaca: Ev tekstili ürünleriniz için hem şık görünen, hem dayanıklı hem de çevre dostu ambalaj arıyorsanız, Interpack Ambalaj'ın ev tekstili kutuları tam size göre."
  ];

  const detergentProducts = [
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/tf9sg3cy_dt1.webp',
      title: 'Zugo Home Mendil Kutusu',
      description: 'Premium mendil kutusu - Taşıma saplı pratik tasarım'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/12wu3xuz_dt2.webp',
      title: 'Tide Deterjan Kutusu',
      description: 'Ultra deterjan ambalajı - 4.08 kg kağıt saplı kutu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/m23r29jx_dt3.jpg',
      title: 'Alpina Colour Deterjan',
      description: 'Çamaşır deterjanı kutusu - 5 kg taşıma saplı ambalaj'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/bprhtkqd_dt4.jpg',
      title: 'Finish Bulaşık Makinesi Tuzu',
      description: 'Bulaşık makinesi tuzu kutusu - 4 kg kağıt saplı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/djsxs6a7_d1.png',
      title: 'ABC Automat Deterjan',
      description: 'Otomatik deterjan kutusu - 5 kg kağıt saplı ambalaj'
    }
  ];

  const detergentDescription = [
    "Interpack Ambalaj'ın deterjan ve temizlik kutuları, temizlik sektöründeki deterjan üreticileri için özel olarak tasarlanmış, yüksek mukavemetli karton kutulardır.",
    "Ağır ve hacimli deterjanları sorunsuz taşıyacak kadar dayanıklı malzeme kullanılır. Kağıt sap uygulaması sayesinde taşınması kolaylaşır ve kullanıcı deneyimi öne çıkar. Kopartma/yırtma bandı gibi kullanıcı dostu detaylar eklenebilir, böylece tüketiciler ürünü kolayca açabilir.",
    "Ofset baskı ile yüksek kaliteli, dikkat çekici tasarımlar yapılabilir. Canlı renkler, net logo baskısı ve ürün bilgileri sayesinde markanız raflarda hemen fark edilir. Özel mukavemetli karton yapısı, ürünlerinizi nakliye ve depolama sırasında korur.",
    "Bu kutular hem yerel hem de global pazarlar için üretilir ve markaların rakiplerinden ayrışmasını sağlayan şık, fonksiyonel ambalaj çözümleri sunar. Interpack Ambalaj, çevreye duyarlı üretim anlayışıyla sürdürülebilir malzemeler kullanır."
  ];

  const paperHandleProducts = [
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/8qjb3p3y_2.jpg',
      title: 'Nespresso Kahve Makinesi Kutusu',
      description: 'Premium kahve makinesi - Kağıt saplı taşıma kolaylığı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/f5x0eivg_3.jpg',
      title: 'K-Classic Ultra Klumpstreu',
      description: 'Premium kedi kumu - 8 litre kağıt saplı kutu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/6jn3pqyg_7.jpg',
      title: 'Signor Gatto Cat Litter',
      description: 'Premium kedi kumu - 6 litre kağıt saplı ambalaj'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/wmmtzy0d_arzum%20sol.jpg',
      title: 'Arzum Tost Makinesi',
      description: 'Arzum tost makinesi - Kağıt saplı ev aleti kutusu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/ou3slk67_dt1.webp',
      title: 'Tide Ultra Deterjan',
      description: 'Tide deterjan - 4.08 kg kağıt saplı ambalaj'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/2zvilxt5_ks1.webp',
      title: 'Sanicat Kedi Kumu',
      description: 'Sanicat Baking Soda - 21 lbs (9.53 kg) kağıt saplı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/n08zobbw_dt2.webp',
      title: 'Alpina Colour Deterjan',
      description: 'Alpina çamaşır deterjanı - 5 kg kağıt saplı kutu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/vhjdymlz_tefal-handle.jpg',
      title: 'Tefal Toast Expert',
      description: 'Tefal tost makinesi - Kağıt saplı taşıma kolaylığı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/ypvxiq8j_dt3.jpg',
      title: 'Finish Salt',
      description: 'Finish bulaşık makinesi tuzu - 4 kg kağıt saplı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/ex2ox4aj_sodastream-sa%C4%9F.jpg',
      title: 'SodaStream Spirit',
      description: 'SodaStream gazlı içecek makinesi - Kağıt saplı'
    }
  ];

  const paperHandleDescription = [
    "Interpack Ambalaj'ın %100 kağıttan üretilmiş kağıt saplı kutuları, kedi ve köpek maması, kedi kumu ile deterjan ve temizlik ürünleri için özel olarak geliştirilmiş, yüksek mukavemetli ambalaj çözümleridir.",
    "15 kg'a kadar taşıma kapasiteli güçlü saplarımızın üretiminde HDPE ekstrüzyon içermemektedir. Tamamen %100 kağıttan üretilmiş, geri dönüştürülebilir olan kağıt saplarımız FDA onaylıdır. Ürün grupları arasında kedi kumu kutuları, deterjan ve temizlik ürünleri kutuları, elektrikli ev aletleri kutuları, kedi & köpek maması kutuları, şarap kutuları ve kargo kutuları bulunmaktadır.",
    "Başlıca avantajlarımız: 15 kg'a varan yük taşıma kapasitesine sahip dayanıklı kağıt sap, %100 kağıt yapısı ile tam geri dönüştürülebilirlik ve yüksek sürdürülebilirlik, BRC Ambalaj belgesiyle gıda güvenliği standartlarına tam uyum, kullanılan tüm malzemelerin FDA onaylı olması sayesinde güvenli ve güvenilir ambalaj, yüksek mukavemetli karton ile üstün koruma ve yük taşıma performansı.",
    "Üstün ofset baskı kalitesiyle raflarda dikkat çeken premium görünüm ve kullanıcı dostu kolay açılır tasarım seçenekleri sunuyoruz. Hem üretim hem lojistik hem de son tüketici aşamasında dayanıklılık, taşıma kolaylığı, güvenlik ve sürdürülebilirlik bir arada."
  ];

  const automotiveProducts = [
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/6q0zh0ct_5.png',
      title: 'MOOG Chassis Parts',
      description: 'NASCAR direksiyon ve süspansiyon parçaları kutusu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/k3vqeab3_y1.webp',
      title: 'MOTHERS PowerPack',
      description: 'Multi-PowerBall oto bakım kiti ambalajı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/tihemg6h_y2.webp',
      title: 'TORO Tempus DC',
      description: 'Sulama kontrol kiti - Farklı boyut seçenekleri'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/qn1fw6bv_y3.webp',
      title: 'OSAKA Piston Part',
      description: 'Motosiklet piston yedek parçası kutusu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/rqkkxuf6_y4.webp',
      title: 'VELBURG Oto Parça',
      description: 'Alternator, Starter, Fuel Pump kutular set'
    }
  ];

  const automotiveDescription = [
    "Interpack Ambalaj'ın otomotiv sektörüne özel tasarlanmış kutuları, yüksek mukavemetli ofset baskılı karton çözümlerdir. Yedek parça, oto aksesuar, filtre, fren balata, amortisör gibi ürünleri en iyi şekilde koruyan, lojistik süreçlerde dayanıklılık gösteren ve raflarda markanızı öne çıkaran ambalajlar üretiyoruz.",
    "Yüksek mukavemetli karton ve sıvamalı yapı ile üstün darbe ve yük koruma performansı sağlıyoruz. Üstün ofset baskı kalitesiyle profesyonel ve dikkat çekici marka görünümü sunuyoruz. Farklı boyut ve tasarımlarda esnek üretim imkanı (tekli veya set ambalaj) ile ihtiyaçlarınıza tam uyum sağlıyoruz.",
    "Dayanıklı yapısıyla uzun mesafe taşımaya ve depolamaya uygundur. İsteğe bağlı iç bölücü (fitment), seperatör ve koruyucu ekler ile ürünlerinizi maksimum güvenlikle taşıyın. Çevre dostu ve geri dönüştürülebilir malzeme seçenekleriyle sürdürülebilirliğe katkı sağlıyoruz.",
    "Hem orijinal ekipman üreticileri (OEM) hem de aftermarket yedek parça markaları için güvenli koruma, kolay taşıma ve premium sunum bir arada. Güçlü koruma, profesyonel görünüm ve dayanıklı taşıma - Otomotiv yedek parçalarınız için en iyi ambalaj partneriniz."
  ];

  const foodProducts = [
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/xbhsdwin_g1.jpg',
      title: 'Cheetos Puffs Promosyon',
      description: 'Cheetos Puffs - 25 daha fazla promosyon kutusu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/46klg7eb_g2.jpg',
      title: 'Ülker Metro Çikolata',
      description: 'Ülker Metro display stand - Mini çikolata kutusu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/pcgtyhm8_gd3.webp',
      title: 'Mango Meyve Kutusu',
      description: 'Mango taşıma kutusu - Havalandırma delikli, saplı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/i80saopb_gd4.webp',
      title: 'Goodfella\'s Pizza',
      description: 'Stone Baked Thin Pepperoni Pizza kutusu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/qvbp7u0s_gd5.webp',
      title: 'Ribe Brygnus Bira Seti',
      description: '3\'lü bira şişe seti - Şeffaf pencereli kraft kutu'
    }
  ];

  const foodDescription = [
    "Interpack Ambalaj'ın gıda sektörüne özel %100 gıda temaslı karton kutu çözümleri, yüksek hijyen ve güvenlik standartlarına uygun olarak üretilir. Kuru gıda, baharat, şekerleme, kuruyemiş, un, irmik, makarna, kahve, çay ve benzeri ürünler için özel olarak tasarlanmış yüksek mukavemetli ambalajlarımız, ürününüzü en iyi şekilde korurken markanızı raflarda öne çıkarır.",
    "Kullanılan tüm kağıtlar FDA onaylıdır ve BRC belgesi ile uluslararası gıda güvenliği standartlarına tam uyum sağlar. Yüksek mukavemetli karton yapısı ile dayanıklı koruma ve uzun raf ömrü sunar. Üstün ofset baskı kalitesiyle göz alıcı ve premium marka görünümü elde edersiniz.",
    "İsteğe bağlı kağıt sap, kolay açılır bandı ve iç bölücü seçenekleri mevcuttur. Tamamen geri dönüştürülebilir ve çevre dostu yapısıyla sürdürülebilir ambalaj çözümü sunarız. Farklı hacim ve boyutlarda esnek üretim imkanı ile her türlü gıda ürününüz için uygun ambalaj üretebiliriz.",
    "Hem üreticiler hem de perakendeciler için güvenli, hijyenik, dayanıklı ve çekici ambalaj çözümü sunuyoruz. Gıda güvenliği, premium görünüm ve sürdürülebilir ambalaj bir arada - Ürünlerinizi koruyan, markanızı güçlendiren ve tüketicinin güvenini kazanan gıda kutuları."
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-lime-600 to-lime-700">
        <div className="container mx-auto px-4">
          <Link 
            to="/urunler" 
            className="inline-flex items-center space-x-2 text-white hover:text-lime-100 mb-8 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Tüm Ürünlere Dön</span>
          </Link>
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold text-white mb-6">
              {category.name}
            </h1>
            <p className="text-xl text-lime-100">
              {isToyCategory 
                ? "Çocukların ilgisini çeken, güvenli ve renkli oyuncak ambalajları" 
                : isPetFoodCategory 
                ? "Pet food sektörü için dayanıklı, hijyenik ve çevre dostu ambalajlar"
                : isCatLitterCategory
                ? "Kedi kumu için sağlam, taşıma kolaylığı sağlayan ambalaj çözümleri"
                : isElectricalCategory
                ? "Elektrikli ev aletleri için koruyucu ve profesyonel ambalaj çözümleri"
                : isHomeTextilesCategory
                ? "Ev tekstili ürünleri için şık, dayanıklı ve fonksiyonel ambalaj tasarımları"
                : isDetergentCategory
                ? "Temizlik sektörü için yüksek mukavemetli, dayanıklı ve kağıt saplı ambalaj çözümleri"
                : isPaperHandleCategory
                ? "%100 kağıttan üretilmiş, 15 kg taşıma kapasiteli, FDA onaylı sürdürülebilir ambalaj"
                : isAutomotiveCategory
                ? "Otomotiv yedek parçaları için yüksek mukavemetli, koruyucu ve profesyonel ambalaj"
                : isFoodCategory
                ? "%100 gıda temaslı, FDA onaylı, BRC belgeli hijyenik ve güvenli gıda ambalajları"
                : category.description}
            </p>
          </div>
        </div>
      </section>

      {/* Toy Product Gallery - Only for Toy Category */}
      {isToyCategory && (
        <section className="py-20 bg-gradient-to-br from-lime-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                {toyProducts.map((product, idx) => (
                  <div 
                    key={idx}
                    className="group bg-white rounded-2xl overflow-hidden border-2 border-lime-100 hover:border-lime-400 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                  >
                    <div className="aspect-square bg-white p-6 flex items-center justify-center overflow-hidden">
                      <img 
                        src={product.url}
                        alt={product.title}
                        className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Toy Description Section - Only for Toy Category */}
      {isToyCategory && (
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="space-y-6">
                {toyDescription.map((paragraph, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-2 h-2 bg-lime-600 rounded-full mt-2"></div>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {paragraph}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Pet Food Product Gallery - Only for Pet Food Category */}
      {isPetFoodCategory && (
        <section className="py-20 bg-gradient-to-br from-lime-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
                {petFoodProducts.map((product, idx) => (
                  <div 
                    key={idx}
                    className="group bg-white rounded-2xl overflow-hidden border-2 border-lime-100 hover:border-lime-400 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                  >
                    <div className="aspect-square bg-white p-6 flex items-center justify-center overflow-hidden">
                      <img 
                        src={product.url}
                        alt={product.title}
                        className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Pet Food Description Section - Only for Pet Food Category */}
      {isPetFoodCategory && (
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="space-y-6">
                {petFoodDescription.map((paragraph, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-2 h-2 bg-lime-600 rounded-full mt-2"></div>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {paragraph}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Cat Litter Product Gallery - Only for Cat Litter Category */}
      {isCatLitterCategory && (
        <section className="py-20 bg-gradient-to-br from-lime-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
                {catLitterProducts.map((product, idx) => (
                  <div 
                    key={idx}
                    className="group bg-white rounded-2xl overflow-hidden border-2 border-lime-100 hover:border-lime-400 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                  >
                    <div className="aspect-square bg-white p-4 flex items-center justify-center overflow-hidden">
                      <img 
                        src={product.url}
                        alt={product.title}
                        className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Cat Litter Description Section - Only for Cat Litter Category */}
      {isCatLitterCategory && (
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="space-y-6">
                {catLitterDescription.map((paragraph, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-2 h-2 bg-lime-600 rounded-full mt-2"></div>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {paragraph}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Electrical Appliances Product Gallery - Only for Electrical Category */}
      {isElectricalCategory && (
        <section className="py-20 bg-gradient-to-br from-lime-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
                {electricalProducts.map((product, idx) => (
                  <div 
                    key={idx}
                    className="group bg-white rounded-2xl overflow-hidden border-2 border-lime-100 hover:border-lime-400 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                  >
                    <div className="aspect-square bg-white p-6 flex items-center justify-center overflow-hidden">
                      <img 
                        src={product.url}
                        alt={product.title}
                        className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Electrical Appliances Description Section - Only for Electrical Category */}
      {isElectricalCategory && (
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="space-y-6">
                {electricalDescription.map((paragraph, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-2 h-2 bg-lime-600 rounded-full mt-2"></div>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {paragraph}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Home Textiles Product Gallery - Only for Home Textiles Category */}
      {isHomeTextilesCategory && (
        <section className="py-20 bg-gradient-to-br from-lime-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
                {homeTextilesProducts.map((product, idx) => (
                  <div 
                    key={idx}
                    className="group bg-white rounded-2xl overflow-hidden border-2 border-lime-100 hover:border-lime-400 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                  >
                    <div className="aspect-square bg-white p-6 flex items-center justify-center overflow-hidden">
                      <img 
                        src={product.url}
                        alt={product.title}
                        className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Home Textiles Description Section - Only for Home Textiles Category */}
      {isHomeTextilesCategory && (
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="space-y-6">
                {homeTextilesDescription.map((paragraph, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-2 h-2 bg-lime-600 rounded-full mt-2"></div>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {paragraph}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Detergent Product Gallery - Only for Detergent Category */}
      {isDetergentCategory && (
        <section className="py-20 bg-gradient-to-br from-lime-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
                {detergentProducts.map((product, idx) => (
                  <div 
                    key={idx}
                    className="group bg-white rounded-2xl overflow-hidden border-2 border-lime-100 hover:border-lime-400 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                  >
                    <div className="aspect-square bg-white p-6 flex items-center justify-center overflow-hidden">
                      <img 
                        src={product.url}
                        alt={product.title}
                        className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Detergent Description Section - Only for Detergent Category */}
      {isDetergentCategory && (
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="space-y-6">
                {detergentDescription.map((paragraph, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-2 h-2 bg-lime-600 rounded-full mt-2"></div>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {paragraph}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Paper Handle Product Gallery - Only for Paper Handle Category */}
      {isPaperHandleCategory && (
        <section className="py-20 bg-gradient-to-br from-lime-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
                {paperHandleProducts.map((product, idx) => (
                  <div 
                    key={idx}
                    className="group bg-white rounded-2xl overflow-hidden border-2 border-lime-100 hover:border-lime-400 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                  >
                    <div className="aspect-square bg-white p-6 flex items-center justify-center overflow-hidden">
                      <img 
                        src={product.url}
                        alt={product.title}
                        className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Paper Handle Description Section - Only for Paper Handle Category */}
      {isPaperHandleCategory && (
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="space-y-6">
                {paperHandleDescription.map((paragraph, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-2 h-2 bg-lime-600 rounded-full mt-2"></div>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {paragraph}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Automotive Product Gallery - Only for Automotive Category */}
      {isAutomotiveCategory && (
        <section className="py-20 bg-gradient-to-br from-lime-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
                {automotiveProducts.map((product, idx) => (
                  <div 
                    key={idx}
                    className="group bg-white rounded-2xl overflow-hidden border-2 border-lime-100 hover:border-lime-400 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                  >
                    <div className="aspect-square bg-white p-6 flex items-center justify-center overflow-hidden">
                      <img 
                        src={product.url}
                        alt={product.title}
                        className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Automotive Description Section - Only for Automotive Category */}
      {isAutomotiveCategory && (
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="space-y-6">
                {automotiveDescription.map((paragraph, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-2 h-2 bg-lime-600 rounded-full mt-2"></div>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {paragraph}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Food Product Gallery - Only for Food Category */}
      {isFoodCategory && (
        <section className="py-20 bg-gradient-to-br from-lime-50 to-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
                {foodProducts.map((product, idx) => (
                  <div 
                    key={idx}
                    className="group bg-white rounded-2xl overflow-hidden border-2 border-lime-100 hover:border-lime-400 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
                  >
                    <div className="aspect-square bg-white p-6 flex items-center justify-center overflow-hidden">
                      <img 
                        src={product.url}
                        alt={product.title}
                        className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Food Description Section - Only for Food Category */}
      {isFoodCategory && (
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="space-y-6">
                {foodDescription.map((paragraph, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-2 h-2 bg-lime-600 rounded-full mt-2"></div>
                    <p className="text-lg text-gray-700 leading-relaxed">
                      {paragraph}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Features */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Ambalaj Özellikleri
            </h2>
            <div className="grid md:grid-cols-3 gap-8">
              {[
                {
                  title: 'Özel Tasarım',
                  desc: 'Markanıza özel, dikkat çekici tasarımlar'
                },
                {
                  title: 'Kaliteli Malzeme',
                  desc: 'Dayanıklı ve güvenli ambalaj malzemeleri'
                },
                {
                  title: 'Hızlı Üretim',
                  desc: 'Zamanında teslimat garantisi'
                }
              ].map((feature, idx) => (
                <div 
                  key={idx}
                  className="text-center p-8 bg-gradient-to-br from-lime-50 to-white rounded-2xl border border-lime-100 hover:shadow-lg transition-all"
                >
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
                  <p className="text-gray-600">{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-lime-600 to-lime-700">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Projeleriniz İçin Teklif Alın
          </h2>
          <p className="text-xl text-lime-100 mb-8 max-w-2xl mx-auto">
            {category.name} kategorisinde ihtiyacınıza özel çözümler sunuyoruz
          </p>
          <Link
            to="/iletisim"
            onClick={() => trackButtonClick('cta_contact', category.slug)}
            className="inline-flex items-center space-x-2 px-8 py-4 bg-white text-lime-600 rounded-lg font-semibold hover:bg-gray-50 transition-all hover:shadow-xl"
          >
            <span>İletişime Geçin</span>
          </Link>
        </div>
      </section>
    </div>
  );
};
